/**
 * Checkout Mercado Pago — /ar/invitacion (delfuocampo).
 * Metadata alineada con otros flujos AR (site, brand, source, PostHog).
 */

import { AR_INVITACION_MEMBERSHIP_NAME, AR_PLANS } from "@/config/arInvitacionPlans";
import { BRAND_PERSON_NAME, BRAND_SITE_HOST, BRAND_SITE_URL, BRAND_SOURCE_KEY } from "@/lib/brandConfig";
import { getPostHogStripeMetadataPostHog } from "@/lib/posthogAnalytics";

const BRAND_KEY = BRAND_SOURCE_KEY || "delfuocampo";

export function buildArInvitacionProductId(invitationCode: string): string {
  const safeCode = invitationCode.replace(/[^A-Za-z0-9_-]/g, "").slice(0, 40);
  return `${BRAND_KEY}_ar_invitation_${safeCode || "link"}_vip`;
}

export function buildArInvitacionMpMetadata(invitationCode: string): Record<string, unknown> {
  const priceArs = AR_PLANS.vip.price;
  return {
    type: "membresia",
    source: BRAND_SOURCE_KEY,
    site: BRAND_SITE_HOST,
    brand: BRAND_PERSON_NAME,
    invitation_code: invitationCode,
    flow: "ar_invitacion",
    plan_tier: "vip",
    product_name: AR_INVITACION_MEMBERSHIP_NAME,
    price_ars: priceArs,
    ...getPostHogStripeMetadataPostHog(),
  };
}

/** Base URL pública para links compartibles (www.delfuocampo.com). */
export function getArInvitacionPublicBaseUrl(): string {
  const fromBrand = BRAND_SITE_URL.trim().replace(/\/+$/, "");
  if (fromBrand) return fromBrand;
  if (typeof window !== "undefined") return window.location.origin.replace(/\/+$/, "");
  return "";
}

export function buildArInvitacionPublicUrl(params: { ref?: string; code?: string }): string {
  const base = getArInvitacionPublicBaseUrl();
  const query = params.ref
    ? `ref=${encodeURIComponent(params.ref)}`
    : params.code
      ? `code=${encodeURIComponent(params.code)}`
      : "";
  return query ? `${base}/ar/invitacion?${query}` : `${base}/ar/invitacion`;
}